import React from 'react';
import {Modal} from 'reactstrap';

const ImageModal = ({open, setOpen, imageData}) => {
    return (
        <Modal
            isOpen={open}
            toggle={() => {
                setOpen(false);
            }}
            centered={true}
        >
            <img src={imageData} className="img-fluid" alt="image_pho" />
        </Modal>
    );
};

export default React.memo(ImageModal);